import {Component, computed, inject, input} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MediaDTO} from '@domain/media/media.dto';
import {FieldBaseComponent} from '@shared/form/field-base.component';
import {HostDTO} from '@domain/host/host.dto';
import {HostApi} from '@domain/host/host.api';
import {CoverUploaderComponent} from '@shared/form/media/cover-uploader/cover-uploader.component';

@Component({
  selector: 'app-host-cover-field',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CoverUploaderComponent
  ],
  templateUrl: './host-cover-field.component.html'
})
export class HostCoverFieldComponent extends FieldBaseComponent<MediaDTO | null> {

  private readonly hostApi = inject(HostApi);

  public readonly host = input.required<HostDTO>();
  public readonly thumbnailUrl = computed(() => this.hostApi.getCoverThumbnailUrl(this.host().id));
  public readonly coverUrl = computed(() => this.hostApi.getCoverUrl(this.host().id));
  // public mediaId = model<string | null>(null);
  // public readonly mediaSelected = output<MediaDTO | null>();

  // public ngOnInit() {
  //   const activityMediaId = this.activity().picture?.id;
  //   if (activityMediaId) {
  //     this.mediaId.set(activityMediaId);
  //   }
  //   super.ngOnInit();
  // }

  // public onMediaUploaded(media: MediaDTO | null): void {
  //   this.mediaId.set(media?.id ?? null);
  //   this.setValue(media);
  // }

  // private setValue(newMedia: MediaDTO | null): void {
  //   this.typedControl().patchValue(newMedia);
  //   this.typedControl().markAsDirty();
  //   this.typedControl().markAsTouched();
  //   this.mediaSelected.emit(newMedia);
  // }

}
